import StyleWrapper from 'common/components/StyleWrapper'
import useBlog, { selectors as blogSelectors } from 'publisher/hooks/useBlog'
import React from 'react'
import { CommonSearch } from 'src/shared/entities/search'
import { SearchInterface } from 'src/shared/types/entities/search-interface'
import { SearchAPIConnector } from './utils/search-api-connector'

interface SearchProps {
  entity: SearchInterface
}

export const Search = ({ entity }: SearchProps) => {
  const blogPath = useBlog(blogSelectors.getBlogPath)

  const connector = new SearchAPIConnector(blogPath)

  const initialSearchTerm = React.useMemo(() => {
    if (typeof window === 'undefined') {
      return ''
    }
    const searchParams = new URLSearchParams(window.location.search)
    return searchParams.get('query') ?? ''
  }, [])

  const config = {
    apiConnector: connector,
    trackUrlState: false,
    searchQuery: {},
    autocompleteQuery: {},
    initialState: {
      searchTerm: initialSearchTerm,
    },
    alwaysSearchOnInitialLoad: false,
  }

  return (
    <StyleWrapper
      styles={entity.margin}
      mobileStyles={entity.mobileMargin}
      desktop={entity.appearance.desktop}
      mobile={entity.appearance.mobile}
    >
      <CommonSearch
        config={config}
        blogPath={blogPath}
        item={entity.item}
        itemTitle={entity.itemTitle}
        itemText={entity.itemText}
        seeMore={entity.seeMore}
        dropdown={entity.dropdown}
        input={entity.input}
      />
    </StyleWrapper>
  )
}
